import { RootState } from '@store';

export const selectDataFromFactoryEquipLevels = (state: RootState) => {
  return state.factoryEquipmentLevels?.dataFromFactoryEquipLevels;
};
